import { useMutation } from '@tanstack/react-query'
import { previewExcelImport } from '../api/minutesApi'
import type { ExcelImportPreview } from '../types'

/**
 * Excel dosyasını doğrulatma mutasyonu (088). Sunucu **kalıcı kayıt yazmaz**; dönen sonuç yalnız ön
 * izlemedir, bu yüzden önbellek geçersizleme (invalidate) yoktur.
 *
 * <p>Hata iki katmanlıdır: dosya/şablon reddi (`4xx`) buradan `onError` ile gelir; **satır hataları
 * başarılı yanıtın verisidir** ve `data.sheets[].errors` içinde taşınır (088 sözleşmesi).
 */
export function useExcelImport() {
  return useMutation<
    ExcelImportPreview,
    unknown,
    { file: File; meetingStartDate?: string | null; meetingId?: number | null }
  >({
    mutationFn: ({ file, meetingStartDate, meetingId }) =>
      previewExcelImport(file, meetingStartDate, meetingId),
  })
}
